import React from 'react';
import { motion } from 'framer-motion';

export default function Cards({ icon, title, description }) {
  return (
    <motion.div
      whileHover={{ y: -8, scale: 1.02 }}
      transition={{ duration: 0.3 }}
      className="relative group bg-gradient-to-br from-gray-900/80 via-purple-900/40 to-gray-900/80 border-2 border-fuchsia-500/30 rounded-2xl p-6 shadow-[0_0_25px_rgba(255,0,255,0.15)] backdrop-blur-md transition-all duration-300 hover:shadow-[0_0_40px_rgba(255,0,255,0.4)] hover:border-fuchsia-500/60 overflow-hidden"
    >
      {/* Animated background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 via-fuchsia-500/0 to-purple-500/0 group-hover:from-cyan-500/10 group-hover:via-fuchsia-500/10 group-hover:to-purple-500/10 transition-all duration-500 -z-10" />
      
      <div className="relative z-10">
        <div className="overflow-hidden rounded-xl mb-4 border-2 border-fuchsia-400/30 group-hover:border-cyan-400/60 transition-all duration-300 shadow-lg">
          {icon}
        </div>
        <h3 className="text-xl font-bold text-fuchsia-400 mb-3 drop-shadow-[0_0_10px_rgba(255,0,255,0.5)] group-hover:text-cyan-400 transition-colors duration-300">
          {title}
        </h3>
        <p className="text-gray-300 text-sm leading-relaxed group-hover:text-gray-200 transition-colors duration-300">
          {description}
        </p>
      </div>
      
      {/* Corner accent */}
      <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-fuchsia-500/20 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </motion.div>
  );
}
